module.exports = __webpack_public_path__ + "img/evaluateLabel.fd1d73b9.png";